<style lang="stylus">
@import '../../../stylesheet/variable.styl'
.cash-pay
  position absolute
  top 0
  bottom 0
  width 100%
  z-index 1000
  background-color rgba(0, 0, 0, .3)
  .cash-pay-wrap
    color rgb(25, 26, 27)
    background-color #fff
    font-size 15px
    height 390px;
    position fixed
    bottom 0
    width 100%
    .cash-pay-title
      justify-content center
      background-color #fff
      height 50px
      line-height 50px
      display flex
      position relative
      align-items center
      &:after
        setBottomLine()
      .close-btn
        height 100%
        position absolute
        right 17.5px
      img
        width 12px
        height 12px
    /* .restTime
        margin-right 15px
        color rgb(255,95,22) */
    .pay-type-list
      height: 250px;

      .item
        background-color #fff
        height 50px
        line-height 50px
        display flex
        position relative
        align-items center
        margin-left 15px
        &:after
          setBottomLine()
        i
          display inline-block
          height 17px
          width 17px
          box-sizing border-box
          border 1px solid rgb(121, 125, 130)
          border-radius 50%
          margin-right 15px
        .checked
          height 18px
          width 18px
          border-radius 50%
          margin-right 15px
        div
          display flex
        .icon
          padding-right 10px
          height 21px
        .pay-type-info
          line-height: 21px;
          display flex
          flex-direction column
        .pay-type-desc
          color rgb(121,125,130)
          font-size 10px
          line-height 15px;
        .check-btn
          position absolute
          right 0px
          top 14.5px
    .pay
      height 44px
      width 92vw
      margin-left 4vw
      border-radius 3px
      position absolute
      bottom 15px
      background-color rgb(255, 95, 22)
      text-align center
      line-height 44px
      color #fff
      font-size 15px
      display flex
      justify-content center
      align-items center
      span
        margin 0
      .yen
        margin-left 8px
        margin-right 2px
        font-size 11px
</style>

<template>
  <div class="cash-pay" v-show="!loading">
    <div class="cash-pay-wrap">
      <div class="cash-pay-title">
        <span>选择支付方式</span>
        <span class="close-btn" @click="cancelPay()">
          <img src="../../../image/preorder/close.png" alt="" />
        </span>
      </div>
      <div class="pay-type-list" :style="{ overflow: morePayType ? 'scroll' : 'hidden' }">
        <div class="item" v-if="!isInWeChatApp && payRenderList.length == 0" @click="chooseAlipay">
          <img class="icon" src="../../../image/preorder/alipay.png" alt="" />
          <div class="pay-type-info"><div class="pay-type-title">支付宝支付</div></div>
          <img class="checked check-btn" src="../../../image/preorder/iconTick.png" v-if="alipayChoosed" />
          <i class="check-btn" v-else></i>
        </div>
        <div class="item" v-if="payRenderList.length == 0" @click="chooseWechat">
          <img class="icon" src="../../../image/preorder/wechat.png" alt="" />
          <div class="pay-type-info"><div class="pay-type-title">微信支付</div></div>
          <img class="checked check-btn" src="../../../image/preorder/iconTick.png" v-if="wechatChoosed" />
          <i class="check-btn" v-else></i>
        </div>

        <div class="item" v-for="(payItem, i) in payRenderList" :key="i" @click="choosePayWay(i)">
          <div style="flex-direction:column">
            <div>
              <img class="icon" :src="payItem.payIcon" alt="" />
              <div class="pay-type-info">
                <div class="pay-type-title" v-if="!payItem.isUniPay">
                  {{ payItem.payDisplayName }}
                </div>
              </div>
            </div>
            <div v-html="payItem.payDesc" v-if="payItem.payDesc" class="pay-type-desc">
              <!-- {{ payItem.payDesc }} -->
            </div>
          </div>
          <img class="checked check-btn" src="../../../image/preorder/iconTick.png" v-if="ifPayWayChoosed(i)" />
          <i class="check-btn" v-else></i>
        </div>
      </div>
      <div @click="loadMorePayType" v-if="!morePayType && payRenderList.length > 5" style="text-align:center;color:rgb(155,155,155)">更多支付方式...</div>
      <div class="pay" @click="toPay">
        <span>支付</span><span class="yen">&yen;</span><span>{{ needPay | price2 }}</span>
      </div>
    </div>

    <cf :time="restTime" :nameOfNextRoute="nextRoute" @close-cf="hideCf" v-if="showCf"> </cf>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import CONSTANT from '../../constant/preorder.js'
import op from 'object-path'
import { getHostName, logout, toLogin, payTypeFilter } from '../../util/function.js'
import cookie from '../../lib/cookie.js'
import { Base64 } from 'js-base64'
import CONSTANT_COOKIE from '../../constant/cookie.js'
import qs from 'querystring'
import moment from 'moment'
import { app } from '../../util/platform'
import cf from './sub_view/cash_comfirm.vue'
import Appbridge from '@maizuo-fe/jk-appbridge'
import _ from 'underscore'

const OVERTIME = '00:00'

export default {
  props: ['payOrderId', 'productsType', 'orderType'],
  data() {
    return {
      payType: CONSTANT.PREORDER_PAY_WECHAT_WAP,
      restTime: '',
      itv: {},
      nextRoute: {},
      showCf: false,
      ensureLeave: false,
      payList: [],
      loading: true,
      morePayType: false,
    }
  },
  components: {
    cf,
  },
  watch: {
    restTime(val) {
      if (val == '00:00') {
        this.showCf = false
        // clearInterval(this.itv)
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.itv)
  },
  computed: {
    ...mapState({
      needPay: state => op(state.order).get('orderDetail.externalPayAmount') || 0,
      endTime: state => op(state.order).get('orderDetail.endPayTime') || 0,
    }),
    isInWeChatApp() {
      //判断是否是在微信中打开
      if (app.isWechat()) {
        return true
      }
      return false
    },
    isInMaizuoApp() {
      //判断是否是在卖座APP中打开
      if (app.isMZFilm()) {
        return true
      }
      return false
    },
    wechatChoosed() {
      if (this.payType == CONSTANT.PREORDER_PAY_WECHAT_WAP || this.payType == CONSTANT.PREORDER_PAY_WECHAT_PUBLIC) {
        return true
      } else {
        return false
      }
    },
    alipayChoosed() {
      if (this.payType == CONSTANT.PREORDER_PAY_ALIPAY_WAP) {
        return true
      }
      return false
    },
    payRenderList() {
      let list = this.payList
      return payTypeFilter(list, this.isInWeChatApp, this.isInMaizuoApp)
    },
  },
  mounted() {
    let self = this
    this.$nextTick(() => {
      const orderId = this.payOrderId
      this.getOrderDetail({
        orderId: orderId,
        type: 2, //2表示orderID是支付号id
      }).then(() => {
        setTimeout(() => {
          this.setOrderInterval()
        }, 0)
      })
      this.getPayWay()
      // 判断是否在微信中打开
      if (this.isInWeChatApp) {
        this.payType = CONSTANT.PREORDER_PAY_WECHAT_PUBLIC
      } else {
        this.payType = CONSTANT.PREORDER_PAY_WECHAT_WAP
      }
    })
  },
  methods: {
    ...mapActions(['getOrderDetail', 'cashPay', 'getCashPayWay', 'getUserOpenId']),
    ifPayWayChoosed(i) {
      if (op(this.payRenderList[i]).get('payType') === this.payType) {
        return true
      }
      return false
    },
    choosePayWay(i) {
      this.payType = this.payRenderList[i].payType
    },
    loadMorePayType() {
      this.morePayType = true
    },
    getPayWay() {
      Indicator.open()

      this.getCashPayWay({
        payOrderId: this.payOrderId,
      })
        .then(payList => {
          this.payList = payList
          Indicator.close()
          this.loading = false
        })
        .catch(e => {
          console.log('payList err', e)
          Indicator.close()
          this.loading = false
        })
    },
    async toPay() {
      const self = this
      let wapReturnUrl = encodeURIComponent(
        getHostName() +
          (this.payType !== CONSTANT.PREORDER_PAY_WECHAT_WAP && this.payType !== CONSTANT.PREORDER_PAY_WECHAT_PUBLIC
            ? `/v5/#/preorder/${this.payOrderId}/pay/callback/`
            : `/v5/#/preorder/${this.payOrderId}/pay/wechat/`) +
          `1?productType=${self.productsType}&orderType=${self.orderType}&rd=${+new Date()}`,
      )
      if (this.payType === CONSTANT.PREORDER_PAY_UNION_PAY) {
        wapReturnUrl = `${getHostName()}/v5/callback?redirectUrl=${encodeURIComponent(
          encodeURIComponent(`/preorder/${this.payOrderId}/pay/callback/1?productType=${self.productsType}&orderType=${self.orderType}&rd=${+new Date()}`),
        )}`
      }

      const openId = await this.getOpenId()

      if (this.payType === CONSTANT.PREORDER_PAY_WECHAT_PUBLIC && !openId) {
        return
      }
      this.cashPay({
        totalPrice: this.needPay,
        payType: this.payType,
        payOrderId: this.payOrderId,
        //这里的rd参数用以保护orderType参数免被微信支付自动添加的参数所污染
        returnUrl: wapReturnUrl,
        openId, // cookie(CONSTANT_COOKIE.COOKIE_USER_THIRD_OPENID) || ''
      })
        .then(data => {
          // 支付宝wap支付
          if (this.payType == CONSTANT.PREORDER_PAY_ALIPAY_WAP) {
            window.location.href = Base64.decode(data.paySign)
            self.$store.commit('·')
            // 微信wap 支付
          } else if (this.payType == CONSTANT.PREORDER_PAY_WECHAT_WAP) {
            let payUrl = `${Base64.decode(op(data).get('paySign'))}`
            let orderId = this.payOrderId
            this.$router.push({
              path:
                '/preorder/' +
                orderId +
                '/pay/wechat/2?payUrl=' +
                encodeURIComponent(payUrl) +
                `&productType=${self.productsType}&orderType=${self.orderType}&rd=${+new Date()}`,
            })
            self.$store.commit('initState')
            // 微信公众号支付
          } else if (this.payType == CONSTANT.PREORDER_PAY_WECHAT_PUBLIC) {
            data.redirect = `${getHostName()}/v5/#/preorder/${this.payOrderId}/pay/callback/2?productType=${self.productsType}&orderType=${
              self.orderType
            }&rd=${+new Date()}`

            data.package = data.packageValue
            window.location.href = `${CONSTANT.PREORDER_WEBCHAT_PUBLIC_PAY_URL}?sign=${Base64.encodeURI(qs.stringify(data))}`
          } else if (this.payType == CONSTANT.PREORDER_PAY_UNION_PAY) {
            document.write(data.paySign)
          }
        })
        .catch(e => {
          if (e.status == CONSTANT.WECHAT_PUBLIC_ERROR) {
            MessageBox({
              message: '哎呀，网络传输出错了，请重新登陆',
              showConfirmButton: true,
              showCancelButton: false,
              confirmButtonText: '重新自动登陆',
              confirmButtonHighlight: true,
              closeOnClickModal: false,
            }).then(() => {
              logout()
              toLogin()
            })
          } else {
            Toast({
              message: e.msg,
              position: 'bottom',
              duration: 3000,
            })
          }
        })
    },
    async getOpenId() {
      if (this.payType === CONSTANT.PREORDER_PAY_WECHAT_PUBLIC) {
        try {
          let data = await this.getUserOpenId()
          return data.openId
        } catch (err) {
          if (err.code === 6814008) {
            // 跳转至绑定 openid 页面
            return MessageBox({
              message: '您尚未绑定苏打优选微信公众号，请先绑定之后再支付。',
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: '去绑定',
              cancelButtonText: '取消',
              cancelButtonHighlight: true,
              closeOnClickModal: true,
            }).then(action => {
              if (action === 'confirm') {
                this.toBindWechatAccount()
              }
            })
          }
          Toast({
            message: err,
          })
          return undefined
        }
      } else {
        return ''
      }
    },
    toBindWechatAccount(url) {
      const toUrl = url || window.location.href
      // const ret = AUTHCONSTANT.AUTH_WECHAT_AUTHORITY_URL + "?url=" + encodeURIComponent(toUrl)
      const ret = `${getHostName()}/mz-auth/connect/wechat/bind?url=${encodeURIComponent(toUrl)}`
      console.log('toBindWechatAccount ret ', ret)
      return (window.location.href = ret)
    },
    chooseWechat() {
      if (this.isInWeChatApp) {
        this.payType = CONSTANT.PREORDER_PAY_WECHAT_PUBLIC
        return
      }
      this.payType = CONSTANT.PREORDER_PAY_WECHAT_WAP
      return
    },
    chooseAlipay() {
      this.payType = CONSTANT.PREORDER_PAY_ALIPAY_WAP
    },
    hideCf(leave) {
      this.showCf = !this.showCf
      if (leave !== undefined) {
        return this.$emit('cancel-cash-pay')
      }
    },
    cancelPay() {
      if (this.restTime == OVERTIME || this.ensureLeave) {
        clearInterval(this.itv)
        return this.$emit('cancel-cash-pay')
      }
      this.showCf = true
    },
    mzFilmV5Pay() {
      const payType = this.payType === CONSTANT.PREORDER_PAY_ALIPAY_WAP ? CONSTANT.PREORDER_PAY_ALIPAY_APP : CONSTANT.PREORDER_PAY_WECHAT_APP
      this.cashPay({
        totalPrice: this.needPay,
        payType,
        payOrderId: this.payOrderId,
      })
        .then(data => {
          const option = {
            payType,
            ...data,
          }
          const returnUrl = `/preorder/${this.payOrderId}/pay/callback/2?productType=${self.productsType}&orderType=${self.orderType}&rd=${+new Date()}`
          Appbridge.listen(data => {
            data = typeof data === 'string' ? JSON.parse(data) : data
            // console.log('App 支付成功', data)
            if (data.type === '402' && data.data === '0') {
              return this.$router.replace({
                path: returnUrl,
              })
            } else {
              Toast({
                message: '支付失败',
                position: 'bottom',
                duration: 3000,
              })
            }
          })
          Appbridge.redirect('to-pay', option)
            .then(data => {
              data = typeof data === 'string' ? JSON.parse(data) : data
              // console.log('App 支付成功', data)
              if (data.type === '402' && data.data === '0') {
                return this.$router.replace({
                  path: returnUrl,
                })
              } else {
                Toast({
                  message: '支付失败',
                  position: 'bottom',
                  duration: 3000,
                })
              }
            })
            .catch(e => {
              Toast({
                message: e.msg,
                position: 'bottom',
                duration: 3000,
              })
            })
        })
        .catch(e => {
          Toast({
            message: e.msg,
            position: 'bottom',
            duration: 3000,
          })
        })
    },
    mzFilmPay() {
      const payType = this.payType === CONSTANT.PREORDER_PAY_ALIPAY_WAP ? CONSTANT.PREORDER_PAY_ALIPAY_APP : CONSTANT.PREORDER_PAY_WECHAT_APP
      this.cashPay({
        totalPrice: this.needPay,
        payType,
        payOrderId: this.payOrderId,
      })
        .then(data => {
          const option = {
            payType,
            ...data,
          }
          const returnUrl = `/preorder/${this.payOrderId}/pay/callback/2?productType=${self.productsType}&orderType=${self.orderType}&rd=${+new Date()}`
          Appbridge.listen(data => {
            data = typeof data === 'string' ? JSON.parse(data) : data
            // console.log('App 支付成功', data)
            if (data.type === '402' && data.data === '0') {
              return this.$router.replace({
                path: returnUrl,
              })
            } else {
              Toast({
                message: '支付失败',
                position: 'bottom',
                duration: 3000,
              })
            }
          })
          Appbridge.redirect('to-pay', option)
            .then(data => {
              data = typeof data === 'string' ? JSON.parse(data) : data
              // console.log('App 支付成功', data)
              if (data.type === '402' && data.data === '0') {
                return this.$router.replace({
                  path: returnUrl,
                })
              } else {
                Toast({
                  message: '支付失败',
                  position: 'bottom',
                  duration: 3000,
                })
              }
            })
            .catch(e => {
              Toast({
                message: e.msg,
                position: 'bottom',
                duration: 3000,
              })
            })
        })
        .catch(e => {
          Toast({
            message: e.msg,
            position: 'bottom',
            duration: 3000,
          })
        })
    },
    setOrderInterval() {
      let self = this
      const now = cookie(CONSTANT_COOKIE.COOKIE_SERVICE_TIME)
      let rest = self.endTime - now
      clearInterval(self.itv)
      self.itv = setInterval(() => {
        rest -= 1
        self.restTime = moment.unix(rest).format('mm:ss')
        if (self.restTime == '00:00' || moment(moment.unix(self.endTime)).isBefore(moment.unix(now))) {
          MessageBox.alert('订单已过期，请重新下单').then(() => {
            self.$router.push({
              name: 'home',
            })
            self.restTime = OVERTIME
            clearInterval(self.itv)
          })
        }
      }, 1000)
    },
  },
}
</script>
